<template>
  <div
    :class="{
      'bookmark-item-sku--for-edit-order': !draggable,
      'bookmark-item-sku--for-edit-order--draggable': draggable
    }"
    @pointerdown="startPress"
    @pointerup="endPress"
    @pointercancel="endPress"
    @pointerleave="endPress"
    @click="endPress"
    @contextmenu.prevent
  >
    <div v-if="draggable" class="bookmark-item-sku--for-edit-order__cover-area">
      <div class="bookmark-item-sku--for-edit-order__cover" />
      <div class="bookmark-item-sku--for-edit-order__cover-tag--move">
        <span class="bookmark-item-sku--for-edit-order__cover-tag-caption">
          移動する
        </span>
      </div>
    </div>
    <div class="bookmark-item-sku--for-edit-order__information-area">
      <ItemSkuBasicInformation
        :image-url="imageUrl"
        :brand-name="brandName"
        :item-name="itemName"
        :item-sku-name="itemSkuName"
        :item-id="itemId"
        :item-sku-id="itemSkuId"
        :out-of-stock="outOfStock"
        class="bookmark-item-sku__sku-basic-information"
      />
    </div>
    <div class="bookmark-item-sku--for-edit-order__control-area">
      <StepperControlBtnUp
        :disabled="isUpButtonDisabled"
        @click-stepper-control-btn-up="clickUp"
      />
      <StepperControlBtnMore @click-stepper-control-btn-more="toggleMoreMenu" />
      <StepperControlBtnDown
        :disabled="isDownButtonDisabled"
        @click-stepper-control-btn-down="clickDown"
      />
      <div
        v-if="showMoreMenu"
        class="bookmark-item-sku--for-edit-order__more-menu-area"
      >
        <ul
          :class="
            isUpButtonDisabled || isDownButtonDisabled
              ? 'bookmark-item-sku--for-edit-order__more-menu--single'
              : 'bookmark-item-sku--for-edit-order__more-menu--double'
          "
        >
          <li
            v-if="!isUpButtonDisabled"
            class="bookmark-item-sku--for-edit-order__more-menu-li--top"
            @click="clickTop"
          >
            最上位に移動する
            <ChevronUp
              class="bookmark-item-sku--for-edit-order__more-menu-icon--top"
            />
          </li>
          <li
            v-if="!isDownButtonDisabled"
            class="bookmark-item-sku--for-edit-order__more-menu-li--bottom"
            @click="clickBottom"
          >
            最下部に移動する
            <ChevronDown
              class="bookmark-item-sku--for-edit-order__more-menu-icon--bottom"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import ItemSkuBasicInformation from '../../atoms/item-sku-bookmark/ItemSkuBasicInformation.vue'
import StepperControlBtnUp from '../../molecules/stepper_control/StepperControlBtnUp.vue'
import StepperControlBtnMore from '../../molecules/stepper_control/StepperControlBtnMore.vue'
import StepperControlBtnDown from '../../molecules/stepper_control/StepperControlBtnDown.vue'
import ChevronUp from '../../atoms/svg_icons/ChevronUp.vue'
import ChevronDown from '../../atoms/svg_icons/ChevronDown.vue'
import { draggableConstants } from '../../../constants/draggableConstants'

const LONG_PRESS_SEC = draggableConstants.LONG_PRESS_SEC

export default {
  components: {
    ItemSkuBasicInformation,
    StepperControlBtnUp,
    StepperControlBtnMore,
    StepperControlBtnDown,
    ChevronUp,
    ChevronDown
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    outOfStock: {
      type: Boolean,
      required: false,
      default: false
    },
    isUpButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isDownButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showMoreMenu: false,
      pressTimer: null,
      draggable: false
    }
  },
  methods: {
    toggleMoreMenu() {
      this.showMoreMenu = !this.showMoreMenu
    },
    closeMoreMenu() {
      this.showMoreMenu = false
    },
    clickUp() {
      this.closeMoreMenu()
      this.$emit('click-up')
    },
    clickDown() {
      this.closeMoreMenu()
      this.$emit('click-down')
    },
    clickTop() {
      this.closeMoreMenu()
      this.$emit('click-top')
    },
    clickBottom() {
      this.closeMoreMenu()
      this.$emit('click-bottom')
    },
    startPress() {
      this.draggable = false
      this.pressTimer = setTimeout(() => {
        this.onLongPress()
      }, LONG_PRESS_SEC)
    },
    endPress() {
      if (!this.pressTimer) return

      clearTimeout(this.pressTimer)
      this.pressTimer = null
      this.draggable = false
    },
    onLongPress() {
      this.draggable = true
    }
  }
}
</script>
<style lang="scss" scoped>
.bookmark-item-sku {
  &--for-edit-order {
    max-width: $small-contents-width;
    padding: 16px;
    margin: auto;
    border-top: 1px solid $gray-2;
    display: flex;
    position: relative;

    &__information-area {
      padding-right: 8px;
      display: flex;
      align-items: center;
      width: 100%;
      overflow-y: hidden;
      cursor: default;
    }

    &__sku-basic-information {
      width: 100%;
      overflow-x: hidden;
      user-select: none;
      -webkit-touch-callout: none;
    }

    &__control-area {
      display: flex;
      gap: 8px;
      flex-direction: column;
    }

    &__more-menu-area {
      position: absolute;
      width: 0;
      height: 0;
    }

    &__more-menu {
      display: flex;
      flex-direction: column;
      background-color: $white;
      border-radius: 8px;
      border: 1px solid $gray-3;
      position: relative;
      left: -180px;
      width: max-content;

      li:not(:first-child) {
        border-top: 1px solid $gray-3;
      }

      &--single {
        @extend .bookmark-item-sku--for-edit-order__more-menu;
        top: 38px;
      }

      &--double {
        @extend .bookmark-item-sku--for-edit-order__more-menu;
        top: 16px;
      }
    }

    &__more-menu-li--top,
    &__more-menu-li--bottom {
      z-index: 1;
      @extend %body;
      line-height: 1.6;
      display: flex;
      flex-direction: row;
      gap: 14px;
      padding: 12px 8px 12px 16px;
      align-items: center;
      cursor: pointer;
    }

    &__more-menu-icon--top,
    &__more-menu-icon--bottom {
      width: 20px;
      height: 20px;
      fill: black;
    }
  }
}

.bookmark-item-sku--for-edit-order--draggable {
  @extend .bookmark-item-sku--for-edit-order;
  position: relative;
  cursor: grab;

  .bookmark-item-sku {
    &--for-edit-order {
      &__cover {
        background: $white_cover;
        opacity: 0.1;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }

      &__cover-tag {
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        &--move {
          @extend .bookmark-item-sku--for-edit-order__cover-tag;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 100px;
          background-color: $primary;
          width: 116px;
          height: 40px;
        }
      }

      &__cover-tag-caption {
        @extend %caption-bold;
        color: $white;
      }

      &__information-area,
      &__control-area {
        opacity: 0.3;
        cursor: default;

        button {
          cursor: default;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
